import styled from '@emotion/styled'
import cn from 'classnames'
import * as React from 'react'

import { menuScreenElementIds } from '~shared/config/menuScreenElementIds'
import { Grid } from '~ui/components/layout/Box'
import { TSingleMargin, TSingleSpace } from '~ui/styleGuide/spaces'

/**
 * Provides a `contentBg` colored background so that the overflowing elements passing around the sticky content are not visible.
 */
const StyledGrid = styled(Grid)`
  &.is-tablet::after {
    content: '';
    height: 100%;
    width: calc(100% + 1rem);
    background-color: inherit;
    position: absolute;
    z-index: -1;
  }
`

type TStyledGridProps = PropsOf<typeof Grid>
type TContainerProps = Pick<TStyledGridProps, 'bgColor' | 'rowGap' | 'height'>

type TProps = RequiredChildren &
  TContainerProps & {
    /**
     * whether the screen is mobile
     */
    isMobile?: boolean
    /**
     * whether the screen is tablet or mobile
     */
    isTabletOrMobile?: boolean
    bottomMargin?: TSingleMargin
    topPadding?: TSingleSpace
  }

const { stickyTopContentId } = menuScreenElementIds

/**
 * Content that remains sticky at the top of the screen.
 */
export const StickyTopContent: React.FC<TProps> = ({
  children,
  isMobile,
  isTabletOrMobile,
  rowGap,
  height,
  bgColor,
  bottomMargin = `none`,
  topPadding = `none`,
}) => {
  return (
    <StyledGrid
      className={cn({ 'is-tablet': isTabletOrMobile && !isMobile })}
      top={0}
      zIndex={1} // TODO zIndex
      position={`sticky`}
      bgColor={bgColor}
      id={stickyTopContentId}
      gridTemplateColumns={`100%`}
      rowGap={rowGap}
      shadow={isMobile ? `onlyBottomLong` : `none`}
      alignItems={isMobile ? `stretch` : `center`}
      height={height}
      margin={{
        bottom: bottomMargin,
        top: `none`,
        left: `none`,
        right: `none`,
      }}
      padding={{ top: topPadding, bottom: `none`, left: `none`, right: `none` }}
    >
      {children}
    </StyledGrid>
  )
}
